<template>

    <div class="relative canvas::editor-admin-Canvas"
         :class="{
            'w-1/3': activeMode === 'overview',
            'w-full': activeMode !== 'overview',
         }"
         ref="canvas"
    >

        <div class="sticky top-0 left-0 z-30 px-8 bg-white bg-opacity-90 backdrop-blur-sm"
            v-show="activeMode === 'content'"
        >

            <button
                v-show="copiedBlockId !== null"
                ref="pasteCanvasBlockButton"
                :class="{ 'opacity-50 pointer-events-none': pastingBlock }"
                class="inline-flex items-center px-5 py-2 my-4 text-sm font-medium leading-4 text-indigo-700 transition bg-indigo-100 bg-opacity-50 border border-transparent rounded-md hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                v-on:click="pasteCanvasBlock(canvasVersion)"
            >
                <svg v-show="pastingBlock" class="w-5 h-5 mr-3 -ml-1 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span class="mb-0 text-lg font-medium leading-normal">Plak blok</span>
            </button>

            <button
                v-show="copiedBlockId !== null"
                ref="removePasteCanvasBlockButton"
                :class="{ 'opacity-50 pointer-events-none': pastingBlock }"
                class="inline-flex items-center px-5 py-2 my-4 ml-4 text-sm font-medium leading-4 text-indigo-700 transition bg-indigo-100 bg-opacity-50 border border-transparent rounded-md hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                v-on:click="removeCopiedBlock();"
            >
                <span class="mb-0 text-lg font-medium leading-normal">Verwijder klembord</span>
            </button>

        </div>

        <button
            v-show="activeMode === 'overview' && primaryLanguage !== language"
            ref="importBlocksBtn"
            class="block w-full px-5 py-5 text-center text-gray-500 transition-all border-2 border-indigo-300 border-dashed rounded hover:bg-indigo-400 hover:border-transparent hover:text-white"
            v-on:click="importCanvasBlocks(canvasVersion)"
            :disabled="importingCanvasBlocks"
        >
            <span v-if="importingCanvasBlocks">
                <i class="fas fa-spinner fa-spin"></i>
            </span>
            <span v-if="!importingCanvasBlocks" class="mb-0 text-lg font-medium leading-normal">Importeer blokken van primaire taal ({{ primaryLanguage }})</span>
        </button>

        <div
            v-if="activeMode === 'overview' && (canvasVersion.canvas_blocks.length == 0 || addInstruction.show)"
            class="px-5 py-5 m-3 text-center bg-white border-gray-500 border-1 addInstruction"
            :class="{
                    saving: stateSaving,
                    hoveredForAddBlock: addInstruction.hoveredForAddBlock,
                }"
            @dragover.prevent="addInstruction.hoveredForAddBlock = true"
            @dragleave.prevent="addInstruction.hoveredForAddBlock = false"
            @drop.prevent="onInstructionDrop">

            <h5 class="mb-0 text-lg font-medium leading-normal">Drag &amp; drop een blok<br/>van rechts</h5>
            <div class="mt-1 text-xs">(of klik het aan)</div>

        </div>

        <div
            v-if="activeMode == 'content' && canvasVersion.canvas_blocks.length == 0"
            class="absolute inset-0 z-10 flex items-center justify-center text-center border-gray-500 bg-gray-50 border-1">

            <div class="flex flex-col items-center">
                <svg class="w-32 h-32 mb-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"></path></svg>
                <h6 class="text-xl text-gray-400">Ga naar het overzicht om een blok toe te voegen</h6>
            </div>

        </div>

        <div
            class="zoomer"
            :style="{
                transform: 'scale(' + scale + ')',
                width: (100 / scale) + '%',
                height: height
            }"
        >

            <div
                class="h-full"
                :style="{
                        padding: activeViewport != 'xl' ? (24 / scale) + 'px ' + (16 / scale) + 'px' : 0,
                    }">

                <div class="h-full m-auto"
                     :style="{
                        maxWidth: activeMode != 'overview' ? viewportWidth + 'px' : '100%',
                     }">

                    <document-iframe
                        ref="iframe"
                        v-show="activeMode == 'content' || (activeMode == 'overview' && canvasVersion.canvas_blocks.length > 0)"
                        :canvasVersion="canvasVersion"
                        :scale="scale"
                        :activeMode="activeMode"
                        @manageResized="manageResized"
                        @manualResize="manualResize"
                        @loaded="$emit('loaded')"
                    />

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import DocumentIframe from "./DocumentIframe";
import delay from "delay";

// TODO Rename Canvas to ..?
export default {

    provide: function ()
    {
        return {
            canvasComponent: this,
        };
    },

    components: {
        DocumentIframe,
    },

    props: {
        canvasVersion: Object,

        activeMode: String,
        activeViewport: String,

        language: String,
        primaryLanguage: String,

        stateSaving: Boolean,
        galleryDraggingBlock: Object,
    },

    data()
    {
        return {
            scale: 1,
            height: 'auto',

            selection: {
                hovers: [],
                focus: {
                    component: null,
                    extra: null,
                },
            },

            addInstruction: {
                show: false,
                hoveredForAddBlock: false,
            },

            pastingBlock: false,
            copiedBlockId: null,
            importingCanvasBlocks: false,
        };
    },

    mounted()
    {
        this.manageScale();
        this.updateCopiedBlockData();
    },

    methods:
    {
        async importCanvasBlocks(canvasVersion)
        {
            if( this.canvasVersion.canvas_blocks.length !== 0 ) {
                await Swal.fire({
                    title: 'Weet u het zeker?',
                    text: 'Je kan er voor kiezen om alle huidige blokken te verwijderen of alleen de blokken van de andere taal toe te voegen zonder de huidige te verwijderen.',
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonText: 'Ja, bewaren',
                    confirmButtonColor: '#55ce62',
                    denyButtonText: 'Overschrijven',
                    cancelButtonText: 'Annuleren',
                }).then((result) => {
                    if(result.isConfirmed) {
                        this.importCanvasBlockPost(true, canvasVersion);
                    } else if(result.isDenied) {
                        this.importCanvasBlockPost(false, canvasVersion);
                    }
                })
            } else {
                await this.importCanvasBlockPost(true, canvasVersion);
            }
        },

        async importCanvasBlockPost(keepCurrentBlocks = true, canvasVersion) {
            let url = '/canvas/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'modules/canvas/' + canvasVersion.canvas_id + '/import-blocks';

            this.importingCanvasBlocks = true;
            this.$emit('importing', true);

            this.$toasted.show('Het importeren van blokken is gestart. Dit kan enkele momenten duren.', {
                duration: 5000,
                type: 'info',
                iconPack: 'fontawesome',
                closeOnSwipe: false,
            });

            try {
                const jobCanvasInformation = await axios.post(url, {
                    keepCurrentBlocks: keepCurrentBlocks,
                    language: $('html').attr('lang'),
                })

                const interval = setInterval(async () => {
                    try {
                        const statusResponse = await axios.post('/canvas/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'modules/canvas/' + canvasVersion.canvas_id + '/job-status', {
                            newCanvasVersionShouldHaveCount: jobCanvasInformation.data.newCanvasVersionShouldHaveCount,
                        });

                        if (!statusResponse.data.processing) {
                            clearInterval(interval); // Stop polling

                            this.$emit('importCompleted', canvasVersion.canvas_id);
                        }
                    } catch (error) {
                        console.error('Error checking job status:', error);
                        clearInterval(interval); // Stop polling on error
                        this.$toasted.show('Er is een fout opgetreden tijdens het importeren. Probeer het opnieuw.', {
                            duration: 5000,
                            type: 'error',
                            iconPack: 'fontawesome',
                            closeOnSwipe: false,
                        });
                        this.importingCanvasBlocks = false;
                        this.$emit('importing', false);
                    }
                }, 2000);
            } catch (error) {
                console.error('Import error:', error);

                this.$toasted.show('Er is een fout opgetreden tijdens het importeren. Probeer het opnieuw.', {
                    duration: 5000,
                    type: 'error',
                    iconPack: 'fontawesome',
                    closeOnSwipe: false,
                });
                this.$emit('importing', false);
            }
        },

        manageScale()
        {
            // No scaling on canvas?
            if (this.activeMode != 'overview')
                this.scale = 1;

            // Set scale to show an lg page?
            else
                this.scale = Math.min($(this.$el).width() / 1500, 1);
        },

        manageResized(messageData)
        {
            // Set height of iframe, but set a minimum so it will not be too small to open the block settings.
            this.height = Math.max(messageData.height * this.scale, 500) + 'px';
        },

        manualResize(height)
        {
            this.height = height;
        },

        onInstructionDrop()
        {
            // @ugly Call iframe
            this.$refs['iframe'].iframeApp.pageComponent.state.canvasVersion.canvas_blocks.push({
                block: this.galleryDraggingBlock.id,
                options: { ...this.galleryDraggingBlock.options, ...this.galleryDraggingBlock.defaultOptions }
            });
        },

        async pasteCanvasBlock(canvasVersion) {
            this.pastingBlock = true;

            let url = '/canvas/' + ($('html').data('prefix') !== undefined
                    ? $('html').data('prefix')
                    : 'admin/'
            ) + 'modules/canvas/' + canvasVersion.canvas_id + '/paste-block/' + this.getCopiedBlock();

            try {
                await axios.post(url)
                    .then(async (requestData) => {
                        if (requestData.data.success === false) {
                            this.$toasted.show(requestData.data.message, {
                                duration: 3000,
                                type: 'error',
                                iconPack: 'fontawesome',
                                closeOnSwipe: false,
                            });
                        } else {
                            await this.$refs['iframe'].iframeApp.pageComponent.state.refresh();

                            this.$refs['iframe'].iframeApp.pageComponent.scrollToLastBlock();

                            this.$toasted.show('Het gekopieerde blok is toegevoegd als laatste blok in dit canvas!', {
                                duration: 5000,
                                type: 'success',
                                iconPack: 'fontawesome',
                                closeOnSwipe: false,
                            });
                        }
                    });
            } catch (e) {
                console.error('Could not paste block: ' + e.error.message + '. This is probably because of a routing issue.');

                this.$toasted.show('Er is iets misgegaan met het kopieren van het blok. Probeer het opnieuw of neem contact op met de website eigenaar.', {
                    duration: 3000,
                    type: 'error',
                    iconPack: 'fontawesome',
                    closeOnSwipe: false,
                });
            }

            this.pastingBlock = false;
        },

        getCopiedBlock() {
            return window.localStorage.getItem('galaxy.admin.canvas.copyBlockId');
        },

        removeCopiedBlock() {
            window.localStorage.removeItem('galaxy.admin.canvas.copyBlockId');

            this.copiedBlockId = null;
        },

        async updateCopiedBlockData() {
            if (this.getCopiedBlock() !== this.copiedBlockId) {
                this.copiedBlockId = this.getCopiedBlock();
            }

            await delay(250);
            await this.updateCopiedBlockData();
        },

    },

    computed: {

        instance()
        {
            return this;
        },

        viewportWidth()
        {
            // Full width due to XL?
            if (this.activeViewport === 'xl') {
                return 10000;
            }

            // @ugly Assuming it will always be website where canvas blocks will be shown.
            // TODO Medium: Setup per canvas to determine which Concord module will be used.
            // Grab tailwind config for screens
            let tailwindConfig = require('@app/tailwind.config.website.js');
            let requiredScreens = {
                'xs': '375px',
                'sm': '640px',
                'md': '768px',
                'lg': '1024px',
                'xl': '1280px',
            }

            // Set default widths if not configured in config
            if (tailwindConfig.theme.screens === undefined) {
                tailwindConfig.theme.screens = requiredScreens;
            } else {
                for (const [key, value] of Object.entries(requiredScreens)) {
                    if (tailwindConfig.theme.screens[key] !== undefined) {
                        continue;
                    }

                    tailwindConfig.theme.screens[key] = value;
                }
            }

            // Get activeViewport screen size from tailwind config to get correct viewport px
            return parseInt(tailwindConfig.theme.screens[this.activeViewport].split('px')[0]);
        },

    },

    watch: {

        async 'activeMode'()
        {
            // @ugly To be able to get the correct new width.
            await delay(1);

            this.manageScale();
        },

        /* TODO Low: See " // Keep showing add .."
        'canvasVersion.id'()
        {console.error('canvasVersion.id watcher');

            // Hide instruction by default.
            this.addInstruction.show = false;
        },

        'canvasVersion.canvas_blocks'(newVal, oldVal)
        {
            console.info('canvasVersion.canvas_blocks watchere');

            // Keep showing add instruction while saving the first block? Our state tells us we already have 1 block, but it is not visible on the screen yet.
            if(oldVal.length == 0 && newVal.length == 1)
                this.addInstruction.show = true;
        },
        */

        'stateSaving'(newVal)
        {
            // Hide show add?
            if (this.canvasVersion.canvas_blocks.length > 0 && !newVal)
                this.addInstruction.show = false;
        }
    }

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-admin-Canvas {
    background: #ecf0f1;

    .addInstruction {
        border: 3px solid white;

        &.saving {
            cursor: wait;
            opacity: .6;
            transition: opacity .2s;

            > * {
                pointer-events: none;
            }
        }

        &.hoveredForAddBlock {
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.12), 0 0px 6px rgba(0, 0, 0, 0.12);
            border-color: #0888c8;
        }

    }

    .zoomer {
        transform-origin: left top;
    }

}

</style>
